<pre class="card card-block card-header">Model: {{selected | json}}</pre>
<input [(ngModel)]="selected"
       [typeahead]="states"
       [typeaheadSingleWords]="true"
       typeaheadPhraseDelimiters="&,"
       class="form-control">
